import { SetActive, SetActiveParams } from '@clerk/types';
import { buildTokenExchangeUrl, NATIVE_APP_SCHEMES } from './nativeAppRedirect';

type HandleClerkRedirectParams = {
  sessionId: string;
  redirectTo?: string;
  setActive: SetActive;
  allowedCustomSchemes?: string[];
  onAfterSuccess?: () => void;
  shouldRedirect?: boolean;
};

export default async function handleSetActive({
  sessionId,
  redirectTo,
  setActive,
  allowedCustomSchemes = NATIVE_APP_SCHEMES,
  onAfterSuccess = () => {
    // noop
  },
  shouldRedirect = true,
}: HandleClerkRedirectParams): Promise<void> {
  if (!sessionId) throw new Error('Missing session ID');

  const isCustomScheme = !!redirectTo && allowedCustomSchemes.some((scheme) => redirectTo.startsWith(scheme));

  if (isCustomScheme) {
    await setActive({ session: sessionId });
    window.location.href = buildTokenExchangeUrl(redirectTo as string);
  } else {
    try {
      const activeObject: SetActiveParams = { session: sessionId };
      if (shouldRedirect) {
        activeObject.redirectUrl = redirectTo || '/';
      }

      await setActive(activeObject);
    } catch (e) {
      console.error(e);
    }
  }

  return onAfterSuccess();
}
